declare global {
  interface Window {
    GLANCE?: any;
  }
}

export function loadGlanceForEmployee (visitorId: string, glanceUrl: string, glanceDataSiteAttribute: string) {
  const script = document.createElement("script");
  script.id = "glance-cobrowse";
  script.src = glanceUrl;
  script.setAttribute("data-groupid", "24570");
  script.setAttribute("data-site", glanceDataSiteAttribute);
  script.setAttribute("data-ws", "www.glance.net");
  script.setAttribute("data-presence", "on");
  script.setAttribute("data-visitorid", visitorId);

  document.head.appendChild(script);
}

export function startEmployeeCobrowse () {
  window.GLANCE.Cobrowse.Visitor.showTerms({
    sessionKey: "GLANCE_KEYTYPE_RANDOM"
  });
}

export function cleanupEmployeeCobrowse () {
  const cobrowseVisitor = window.GLANCE?.Cobrowse?.Visitor;
  if (cobrowseVisitor?.inSession?.()) {
    cobrowseVisitor.stopSession();
  }

  const presenceVisitor = window.GLANCE?.Presence?.Visitor?.instance;
  if (presenceVisitor?.disconnect) {
    presenceVisitor.disconnect();
  }

  document.querySelectorAll('script[id="glance-cobrowse"], script[src*="CobrowseJS"]').forEach(s => s.remove());
}
